import { GlLink } from '@gitlab/ui';
import HiddenBadge from '~/issuable/components/hidden_badge.vue';
import LockedBadge from '~/issuable/components/locked_badge.vue';
import ArchivedBadge from '~/issuable/components/archived_badge.vue';
import { NAMESPACE_PROJECT } from '~/issues/constants';
import ConfidentialityBadge from '~/vue_shared/components/confidentiality_badge.vue';
import ImportedBadge from '~/vue_shared/components/imported_badge.vue';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import WorkItemTypeIcon from '~/work_items/components/work_item_type_icon.vue';
import { findNotesWidget } from '../utils';
import WorkItemStateBadge from './work_item_state_badge.vue';
export default {
    name: 'WorkItemStickyHeader',
    components: {
        HiddenBadge,
        ImportedBadge,
        LockedBadge,
        ArchivedBadge,
        ConfidentialityBadge,
        WorkItemStateBadge,
        GlLink,
        WorkItemTypeIcon
    },
    directives: {
        SafeHtml
    },
    props: {
        workItem: {
            type: Object,
            required: true
        },
        isDrawer: {
            type: Boolean,
            required: false,
            default: false
        },
        archived: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        isDiscussionLocked () {
            return findNotesWidget(this.workItem)?.discussionLocked;
        },
        workItemType () {
            return this.workItem.workItemType?.name;
        },
        workItemTypeIconName () {
            return this.workItem.workItemType?.iconName;
        },
        workItemState () {
            return this.workItem.state;
        }
    },
    NAMESPACE_PROJECT,
    TITLE_CLASS: 'gl-mr-auto gl-block gl-truncate gl-pr-3 gl-font-bold gl-text-strong',
    titleInLinkSafeHtmlConfig
};
